import { TDeviceType } from '@cian/ui-kit';
import { IBuildersProjectsData } from '../../../shared/types/buildersProjects';
import { getAnalyticsPage, getAnalyticsProducts } from '../../../shared/utils/analytics';

interface ICreateCianAnalyticsPageViewObjectParams {
  buildersProjects?: IBuildersProjectsData;
  deviceType: TDeviceType;
  userId?: number;
}

export function createCianAnalyticsPageViewObject({
  buildersProjects,
  deviceType,
  userId,
}: ICreateCianAnalyticsPageViewObjectParams) {
  const cianAnalyticsPageViewObject = {
    page: getAnalyticsPage({ pageNumber: buildersProjects?.page, deviceType }),
    products: getAnalyticsProducts(buildersProjects),
    user: userId ? { userId } : {},
  };

  return cianAnalyticsPageViewObject;
}
